import { Box, Grid, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import NewProposal from "../Components/Dashboard/NewProposal";
import MyReviews from "../Components/Dashboard/MyReviews";
import MyEvaluations from "../Components/Dashboard/MyEvaluations";
import service from "../Helpers/gifservices";
import { useCallback, useEffect, useState } from "react";
import { RefereeAnswers } from "../Constants.js";
import { useLoading } from "../../../providers/loadingProvider";
import {
  setCanEdit,
  setReferee,
  setRefereeStatus,
} from "../../../store/refereeSlice";
import { useDispatch } from "react-redux";
import DeclineReviews from "../Components/Dashboard/DeclineReviews";
import { Info } from "@material-ui/icons";

const pageName = "Dashboard";

const Dashboard = (props) => {
  const loading = useLoading();
  const dispatch = useDispatch();
  const [potentialProposalReferee, setPotentialProposalReferee] = useState();
  const [historyProposalReferees, setHistoryProposalReferees] = useState([]);
  const [declineProposalReferees, setDeclineProposalReferees] = useState([]);
  const [evaluationProposalReferees, setEvaluationProposalReferees] = useState(
    []
  );

  const agreeToEvaluateProposalReferee = async (proposalRefereeId) => {
    const loadingId = loading.addLoading("Updating");
    await service.UpdateProposalRefereeAnswer({
      proposalRefereeId: proposalRefereeId,
      status: RefereeAnswers.AgreeToEvaluate,
    });
    GetProposalReferees();
    loading.removeLoading(loadingId);
  };

  const declineToEvaluateProposalReferee = async (
    proposalRefereeId,
    declineReason,
    details
  ) => {
    const loadingId = loading.addLoading("Updating");
    await service.UpdateProposalRefereeAnswer({
      proposalRefereeId: proposalRefereeId,
      status: declineReason,
      details: details,
    });
    GetProposalReferees();
    loading.removeLoading(loadingId);
  };

  const GetProposalReferees = useCallback(async () => {
    const loadingId = loading.addLoading("Loading Proposals");
    var proposalReferees = await service.GetProposalRefereesGroupedByStatus();
    var history = proposalReferees.sentEvaluation;
    var decline = proposalReferees.declinedEvaluating;
    var potential = [
      // ...proposalReferees.potential,
      ...proposalReferees.sentFirstMail,
      ...proposalReferees.sentFirstMailReminder,
    ];
    var evaluation = [
      ...proposalReferees.evaluationEmailReminder,
      ...proposalReferees.agreeToEvaluate,
    ];
    setPotentialProposalReferee(null);
    if (potential.length > 1)
      console.error(
        "Found more then 1 potential proposalReferee (Need To Be 1) - Can Show Only One "
      );
    if (potential.length === 1) setPotentialProposalReferee(potential[0]);
    setHistoryProposalReferees(history);
    setDeclineProposalReferees(decline);
    setEvaluationProposalReferees(evaluation);
    loading.removeLoading(loadingId);
  }, [loading]);

  useEffect(() => {
    GetProposalReferees();
    dispatch(setReferee(null));
    dispatch(setRefereeStatus(null));
    dispatch(setCanEdit(false));
  }, [GetProposalReferees, dispatch]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item>
          <Typography variant="subtitle2">{pageName}</Typography>
        </Grid>
        <Grid item>
          <InfoOutlinedIcon color="primary" />
        </Grid>
        <Grid item xs={12}>
          <NewProposal
            proposalReferee={potentialProposalReferee}
            acceptProposal={agreeToEvaluateProposalReferee}
            declineProposal={declineToEvaluateProposalReferee}
          />
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ display: "flex" ,alignItems:"center"}}>
            <Info fontSize="small" color="primary"/>
            <Typography sx={{ marginLeft: 2 }} >
              Please click on the proposal number to open the online evaluation
              form
            </Typography>
          </Box>
        </Grid>
        {evaluationProposalReferees.length > 0 && (
          <Grid item xs={12}>
            <Box padding={1}>
              <MyEvaluations proposalReferees={evaluationProposalReferees} />
            </Box>
          </Grid>
        )}
        {historyProposalReferees.length > 0 && (
          <Grid item xs={12}>
            <Box padding={1}>
              <MyReviews proposalReferees={historyProposalReferees} />
            </Box>
          </Grid>
        )}
        {declineProposalReferees.length > 0 && (
          <Grid item xs={12}>
            <Box padding={1}>
              <DeclineReviews proposalReferees={declineProposalReferees} />
            </Box>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default Dashboard;
